import { useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { DialogContent, Grid, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, InputAdornment, TableHead, TableRow, Typography, FormControl, ListItemText, Checkbox, TextField, Button } from "@mui/material";
import CommonModal from "../../../UserScreen/InventoryPage/InventorySettings/components/Modals/CommonModal";
import OrgSelection from "../../OrgSelection";
import _ from "lodash";
import SearchIcon from "@material-ui/icons/Search";
import { getUserTerminalsForAssign, moveUserTerminals, ACTION_TYPES } from "../slice";
import TablePagination from "../../../UserScreen/InventoryPage/InventorySettings/components/TablePagination";
import { toast } from "react-toastify";

const AssignUserTerminalToSubOrg = (props) => {
    const { open, setOpen, authReducer, userTerminals, totalUserTerminals, getUserTerminalsForAssign, moveUserTerminals, moveUserTerminal } = props;
    const dispatch = useDispatch();
    const [sourceOrg, setSourceOrg] = useState<any>(null);
    const [destOrg, setDestOrg] = useState<any>(null);
    const [searchText, setSearchText] = useState("");
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(25);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [highlightedRows, setHighlightedRows] = useState<any>([]);
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const [userTerminalsLocal, setUserTerminalsLocal] = useState([])

    useEffect(() => {
        if (open && authReducer?.selectedOu) {
            setSourceOrg({ id: authReducer.selectedOu.id, name: authReducer.selectedOu.name });
            setDestOrg({ id: authReducer.selectedOu.id, name: authReducer.selectedOu.name });
            setDestOrg(null);
            setHighlightedRows([]);
            setPage(1);
            setSearchText("");
        }
    }, [open, authReducer?.selectedOu]);

    useEffect(() => {
        if (!open || !sourceOrg?.id) return;

        setUserTerminalsLocal([])

        getUserTerminalsForAssign({
            dpIds: [sourceOrg.id],
            accounts: [],
            searchText: debouncedSearch,
            sortBy: 'userTerminalId',
            sortOrder: 'asc',
            page,
            limit: size,
            terminalStatus: ['in-warehouse'],
            serviceLines: []
        });

    }, [open, sourceOrg?.id, page, size, debouncedSearch]);

    useEffect(()=>{
        if(userTerminals){
            setUserTerminalsLocal(userTerminals)
        }

    },[userTerminals])


    useEffect(() => {
        if (!_.isEmpty(moveUserTerminal)) {
            if (moveUserTerminal && moveUserTerminal?.success) {
                toast.success("User terminal assigned successfully. Changes will reflect shortly.", { position: toast.POSITION.BOTTOM_LEFT });
            } else {
                toast.error(moveUserTerminal?.message, { position: toast.POSITION.BOTTOM_LEFT });
            }
            dispatch({ type: ACTION_TYPES.ASSIGN_USER_TERMINAL_TO_SUBORG, payload: [] });
        }
    }, [moveUserTerminal])

    const handleSearchChange = (e) => { setSearchText(e.target.value) };

    const handlePageChange = (newPage) => { setPage(newPage); };

    const handleSizeChange = (value) => { setSize(value); setPage(1); };

    const handleVerify = () => { setConfirmOpen(true); };

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedSearch(searchText);
        }, 500);

        return () => clearTimeout(timer);
    }, [searchText]);

    const handleConfirmSubmit = () => {
        moveUserTerminals({ organizationId: destOrg?.id, userTerminalIds: highlightedRows?.map((row) => row?.userTerminalId) })
        setConfirmOpen(false);
        setOpen(false);
    };

    const handleHighlightedRowClick = (row) => {
        setHighlightedRows((prevHighlighted) => {
            const exists = prevHighlighted.some((item) => item?.userTerminalId === row?.userTerminalId);
            return exists
                ? prevHighlighted.filter((item) => item?.userTerminalId !== row?.userTerminalId)
                : [...prevHighlighted, row];
        });
    };

    const isHighlighted = (userTerminalId: string) => {
        return highlightedRows.some((item) => item.userTerminalId === userTerminalId);
    };

    return (
        <>
            <CommonModal
                open={open}
                onClose={() => setOpen(false)}
                title="Assign User Terminals"
                saveText="VERIFY"
                cancelText="Clear"
                onSave={handleVerify}
                showCancel={false}
                width="650px"
                showOnlineOffline={false}
                showSyncStatus={false}
                disableSave={highlightedRows?.length === 0 || !destOrg}
            >
                <div className="str-user-terminal-padding">
                    <Grid container spacing={2} paddingBottom={1}>
                        <Grid item xs={6}>
                            <OrgSelection label="Organization" value={destOrg} onChange={setDestOrg} />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                variant="outlined"
                                placeholder="Search..."
                                size="small"
                                value={searchText}
                                onChange={handleSearchChange}
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Grid>
                    </Grid>

                    <TablePagination rowsPerPageOptions={[10, 25, 50, 100]} rowsPerPage={size} onRowsPerPageChange={handleSizeChange} onPageChange={handlePageChange} page={page} totalRowCount={totalUserTerminals || 0} />

                    <TableContainer component={Paper} className="str-user-terminal-table starlink--table_container" >
                        <Table stickyHeader size="small" aria-label="plan-hierarchy-table" sx={{ tableLayout: "fixed" }}>
                            <TableHead>
                                <TableRow >
                                    <TableCell align="center">User Terminals</TableCell>
                                    <TableCell align="center">Organization</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody className="strPlan-sl-table">
                                {userTerminalsLocal?.length > 0 ? (
                                    userTerminalsLocal?.map((ut:any) => (
                                        <TableRow key={ut.userTerminalId} hover onClick={() => { handleHighlightedRowClick(ut) }} role="checkbox">
                                            <TableCell align="center" className={`strPlans-table-cell ${isHighlighted(ut?.userTerminalId) ? 'highlighted' : ''}`}>{ut.kitSerialNumber || ut.userTerminalId}</TableCell>
                                            <TableCell align="center" className={`strPlans-table-cell ${isHighlighted(ut?.userTerminalId) ? 'highlighted' : ''}`}>{ut.accountDpName}</TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={2} align="center">No terminals found</TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Grid container spacing={2} padding={1}>
                        <Grid item>  <Button variant="outlined" onClick={() => { setHighlightedRows([]) }}>Clear</Button>   </Grid>
                        <Grid item> <Button variant="outlined" onClick={() => { setHighlightedRows([...userTerminalsLocal]) }}>Select All</Button> </Grid>
                    </Grid>
                </div>
            </CommonModal>

            <CommonModal
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                title="Assigning User Terminals"
                saveText="Submit"
                cancelText="Go Back"
                onSave={handleConfirmSubmit}
                width="600px"
                showOnlineOffline={false}
                showSyncStatus={false}
                onCancelSave={() => setConfirmOpen(false)}
            >
                <DialogContent>
                    <Typography gutterBottom>
                        Following User Terminals will be assigned to <b>{destOrg?.name}</b>:
                    </Typography>

                    <FormControl fullWidth size="small">
                        <Select
                            multiple
                            value={highlightedRows}
                            renderValue={(selected) => {
                                const labels = selected.map(s => s.kitSerialNumber);
                                if (labels.length > 2) {
                                    return `${labels[0]}, ${labels[1]} + ${labels.length - 2}`;
                                }
                                return labels.join(", ");
                            }}
                            MenuProps={{
                                PaperProps: {
                                    style: { maxHeight: 300 }
                                }
                            }}
                        >
                            {highlightedRows?.map((ut, index) => (
                                <MenuItem key={ut.userTerminalId} value={ut}>
                                    <div className="strPlan-index">
                                        {index + 1}.
                                    </div>

                                    <ListItemText
                                        primary={ut.kitSerialNumber}
                                        secondary={`ID: ${ut.userTerminalId}`}
                                    />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                </DialogContent>
            </CommonModal>
        </>
    );
};

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    userTerminals: state.starlinkAdmin.userTerminalsForAssign,
    totalUserTerminals: state.starlinkAdmin.totalAssignUserTerminals,
    moveUserTerminal: state.starlinkAdmin.moveUserTerminal
});

export default connect(mapStateToProps, { getUserTerminalsForAssign, moveUserTerminals })(AssignUserTerminalToSubOrg);
